// import ComponentA from './Components/ComponentA'

import Menu from "./Components/Menu"
import Popup from "./Components/Popup"

document.addEventListener('DOMContentLoaded', () => {
    let root = {}
    root.menu = new Menu(root, [])
    root.menu.run()

    root.popup = new Popup(root, [])
    root.popup.run()
}, false)
